import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, LogOut } from 'lucide-react';
import { mainNavItems, bottomNavItems, isPathActive } from './NavigationItems';
import { useOpenIdeaCount } from '../hooks/useOpenIdeaCount';

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  onSignOut: () => void;
}

export function MobileNav({ isOpen, onClose, onSignOut }: MobileNavProps) {
  const location = useLocation();
  const ideaCount = useOpenIdeaCount();

  const handleSignOut = () => {
    onClose();
    onSignOut();
  };

  const handleKnowledgeClick = () => {
    onClose();
    const event = new CustomEvent('openKnowledge');
    window.dispatchEvent(event);
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 w-64 bg-white border-r border-gray-200 z-50 lg:hidden transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
            <img
              src="https://cdn.prod.website-files.com/68106eab8acafbe1be69f17a/6830b7212ae8f51f0b5e545b_12ebc92fd52362293d48e2636ef26ed3_logo.svg"
              alt="Dibbi Logo"
              className="h-8"
            />
            <button
              onClick={onClose}
              className="p-2 text-gray-700 hover:text-[#FF6B35] hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
            {mainNavItems.map((item) => {
              const isActive = isPathActive(location.pathname, item);
              const Icon = item.icon;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={onClose}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-[#FF6B35] text-white'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35]'
                  }`}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span>{item.label}</span>
                  {item.path === '/ideeen' && ideaCount > 0 && (
                    <span className={`ml-auto text-xs font-semibold rounded-full px-2 py-0.5 min-w-[20px] text-center ${
                      isActive ? 'bg-white text-[#FF6B35]' : 'bg-[#FF6B35] text-white'
                    }`}>
                      {ideaCount}
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>

          <div className="border-t border-gray-200">
            <div className="px-3 py-4 space-y-1">
              {bottomNavItems.map((item) => {
                const Icon = item.icon;

                if (item.path === '/kennisbank') {
                  return (
                    <button
                      key={item.path}
                      onClick={handleKnowledgeClick}
                      className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35] transition-colors w-full"
                    >
                      <Icon className="w-5 h-5 flex-shrink-0" />
                      <span>{item.label}</span>
                    </button>
                  );
                }

                const isActive = isPathActive(location.pathname, item);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={onClose}
                    className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-[#FF6B35] text-white'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35]'
                    }`}
                  >
                    <Icon className="w-5 h-5 flex-shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}

              <button
                onClick={handleSignOut}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35] transition-colors w-full"
              >
                <LogOut className="w-5 h-5 flex-shrink-0" />
                <span>Uitloggen</span>
              </button>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
